// @ts-nocheck
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import LoadingOverlay from 'components/common/LoadingOverlay';
import { authStartup, initializeParamountPlusUser } from 'actions/auth';

import useInterval from 'hooks/interval';

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const providers = useSelector(state => state.kitchenSink.data.providers);
  const contentError = useSelector(state => state.kitchenSink.error);

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      await dispatch(authStartup());
      setInitialized(true);
    };

    if (!initialized && providers) {
      initializeAuth();
    }
  }, [providers, dispatch, initialized]);

  const expiresIn = useSelector(
    state => state.auth?.paramountPlus?.token?.expiresIn,
  );
  useInterval(() => {
    if (expiresIn) {
      dispatch(initializeParamountPlusUser());
    }
  }, expiresIn);

  if (!initialized) {
    return contentError ? null : <LoadingOverlay />;
  }

  return children;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
